import React from 'react';
import { useTranslation } from 'react-i18next';
import './PartnersSection.scss';

const ITEM_IMGS = [
  'https://pub-99c08cb1333848799ea7396fa0c922e1.r2.dev/sso/LOGO%20PLE%20(35).jpg',
  'https://pub-99c08cb1333848799ea7396fa0c922e1.r2.dev/sso/LOGO%20PLE%20(38).jpg',
  'https://pub-99c08cb1333848799ea7396fa0c922e1.r2.dev/sso/LOGO%20PLE%20(36).jpg',
  'https://pub-99c08cb1333848799ea7396fa0c922e1.r2.dev/sso/LOGO%20PLE%20(34).jpg',
];

const NetworkSection: React.FC = () => {
  const { t } = useTranslation();
  const items = t('trangChu.network.items', { returnObjects: true }) as { title: string; desc: string }[];

  return (
    <section className="net" aria-label={t('trangChu.network.sectionAria')} data-reveal data-anim="up">
      <div className="net__container">

        {/* Header */}
        <div className="net__header" data-reveal data-anim="up">
          <span className="net__eyebrow">{t('trangChu.network.eyebrow')}</span>
          <h2 className="net__heading">
            {t('trangChu.network.heading')} <span className="net__accent">{t('trangChu.network.headingAccent')}</span>
          </h2>
          <p className="net__subtext">{t('trangChu.network.subtext')}</p>
        </div>

        {/* Image grid */}
        <div className="net__grid">
          {items.map((item, i) => (
            <div key={i} className={`net__card net__card--${i}`}>
              <img src={ITEM_IMGS[i]} alt={item.title} className="net__img" loading="lazy" />
              <div className="net__overlay" aria-hidden="true" />
              <div className="net__info">
                <strong className="net__title">{item.title}</strong>
                <span className="net__desc-sm">{item.desc}</span>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default NetworkSection;
